import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
//获得用户信息
function getUserInfo(state) {
    if (state.userInfo) return state.userInfo;
    let userInfo = localStorage.getItem(keys.USER);
    if (userInfo) {
        state.userInfo = JSON.parse(userInfo);
    }
    return state.userInfo;
}
const keys = { USER: 'user' }//保存在本地的key
const state = {
    userInfo:"",
    sysConfig:{}
  }
  const getters = {
    //getUserInfo: state => state.userInfo,
    getUserInfo: (state) => () => {
        getUserInfo(state);
        return state.userInfo;
    },
    getToken: (state) => () => {
        getUserInfo(state);
        if (state.userInfo) {
            return 'Bearer ' + state.userInfo.accessToken;
        }
        return '';
    },
    isLogin: (state) => () => {
        if (getUserInfo(state)) {
            console.log("真的")
            return true;
        }
        console.log("假的")
        return false;
    },
    getSysConfig:state=>state.sysConfig,
  }
  const mutations = {
    setConfig(state,data)
    {
      state.sysConfig=data
    },
    setUserInfo (state, data) {
      state.userInfo = data
      localStorage.setItem(keys.USER, JSON.stringify(data));
    },
    clearUserInfo(state) {
        state.userInfo=null;
        localStorage.removeItem(keys.USER);
    },
  

  }
  export default new Vuex.Store({
    state,
    getters,
    mutations
  })


// WEBPACK FOOTER //
// ./src/store/index.js